"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetToolbar = void 0;
var react_1 = __importDefault(require("react"));
var EditorWidgetRegistry_1 = require("../WidgetRegistry/EditorWidgetRegistry");
var useSelectionState_1 = require("./useSelectionState");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var WidgetManager_1 = require("../WidgetManager");
var inversify_react_1 = require("inversify-react");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var WidgetToolbar = function (_a) {
    var _b;
    var element = _a.element, anchorElement = _a.anchorElement;
    var widgetSelectionState = (0, useSelectionState_1.useSelectionState)(element).widgetSelectionState;
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var WidgetButtons = (_b = (0, EditorWidgetRegistry_1.getGenericConfigByType)(element.type)) === null || _b === void 0 ? void 0 : _b.toolbarButtons;
    return (react_1.default.createElement(kaleidoscope_1.Toolbar, { element: anchorElement, visible: widgetSelectionState === "circle", positionType: kaleidoscope_1.ToolbarPositionType.Element },
        WidgetButtons ? react_1.default.createElement(WidgetButtons, { element: element }) : null,
        react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.Delete, null), tooltip: { content: "delete" }, onClick: function () {
                widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("any", {
                    action: "delete",
                    path: widgetManager.getPath(element),
                    type: element.type,
                }));
            }, isDestructive: true })));
};
exports.WidgetToolbar = WidgetToolbar;
